import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upgrade-image-container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "upgrade-content" }
const _hoisted_4 = {
  key: 0,
  class: "switch"
}
const _hoisted_5 = ["checked"]
const _hoisted_6 = { class: "upgrade-content-wr" }
const _hoisted_7 = { class: "upgrade-title" }
const _hoisted_8 = { class: "upgrade-details" }
const _hoisted_9 = { class: "upgrade-price" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "upgrade-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["upgrade-option", { selected: $setup.isEnabled }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (!$setup.isDesktop && $setup.handleToggleEnabled()), ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "upgrade-image",
        src: $props.url,
        alt: `House upgrade option image: ${$props.name}`,
        draggable: "false"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      ($setup.isDesktop)
        ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: $setup.isEnabled,
              onClick: $setup.handleToggleEnabled
            }, null, 8, _hoisted_5),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "slider round" }, null, -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString($props.name), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString($setup.formatPrice($props.price)), 1)
        ])
      ]),
      ($props.includedItems?.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "separator" }, null, -1)),
            _createElementVNode("button", {
              class: "expand-button",
              onClick: _withModifiers($setup.handleToggleExpanded, ["stop"])
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "expand-button-text" }, "What's included", -1)),
              _createElementVNode("img", {
                class: _normalizeClass(["arrow", { 'arrow--up': $setup.isExpanded }]),
                src: $setup.ArrowUpLanding,
                alt: "Expand arrow"
              }, null, 10, _hoisted_10)
            ]),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                ($setup.isExpanded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.includedItems, (item) => {
                          return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}